/* eslint-disable react/no-unused-prop-types */
import { t } from '@lingui/macro';
import { arrayOf, shape, string } from 'prop-types';
import { ENTITY_TYPES } from '../../../services/EntityService';
import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropDefaults, filterPropTypes } from '../../page-framework/filter/FilterPropTypes';

import EntityTagGroupFilter from '../entity-tag-group-filter/EntityTagGroupFilter';
import getEntityTagGroupFilterServiceFactory from '../entity-tag-group-filter/EntityTagGroupFilterServiceFactory';

export const filterId = 'BusinessServicesGroup';

export const filterTitle = t`Business Services`;

function BusinessServiceGroupFilter(props) {
    const { state, filterActions } = props;

    return (
        <EntityTagGroupFilter state={state} filterActions={filterActions} entityType={ENTITY_TYPES.BUSINESS_SERVICE} />
    );
}

BusinessServiceGroupFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        tags: arrayOf(string),
        tagOp: string,
        businessServices: arrayOf(string),
    }),
};

BusinessServiceGroupFilter.defaultProps = {
    ...filterPropDefaults,

    id: filterId,
    title: filterTitle,
    state: undefined,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityTagGroupFilterServiceFactory(ENTITY_TYPES.BUSINESS_SERVICE),
})(BusinessServiceGroupFilter);
